import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'

import Header from '../components/Header/Header.js'
import Footer from '../components/Footer/Footer.js'
import Button from '../components/Button/Button.js'

import TestForm from '../components/_TestComponents/TestForm.js'

import { showTooltip, hideTooltip } from '../actions/actions.export.js';

var pf_config = require('../pf_config.json');

class FeatureTable extends Component {
  constructor(props){
    super(props);
  }

  render(){
    const { dispatch, user } = this.props;

    return <div className="landing">
      <div className="screen-height-container bg-gradient">
        <div className="shc-background translucent">
          <img src="/img/herring-bone.png" width="100%"/>
        </div>
        <div className="shc-content">
          <Header transparent={true}/>
          <div className="container">
            <div className="row row-mega-padded justify-content-center">
              <div className="col-md-6">
                <div className="col-themed">
                  <TestForm/>
                </div>
              </div>
            </div>
          </div>
        </div> 
      </div>
      <Footer/>
    </div>
  }
}

const mapStateToProps = (state) => {
  const { user } = state;

  return {
    user
  }
}

export default connect(mapStateToProps)(FeatureTable);



// WEBPACK FOOTER //
// ./src/routes/_TestRoute.js